const services = [
  {
    icon: 'ri-home-move-line',
    title: 'Residential Moving',
    subtitle: 'Home Moves Done Right',
    description: 'Moving your home is one of life\'s biggest transitions. Our residential moving specialists handle every detail — from careful furniture wrapping to navigating tight doorways — treating your home like our own.',
    features: ['Full furniture disassembly & reassembly', 'Floor & wall protection included', 'Apartment & house moves', 'Same-day availability', 'Stress-free process guaranteed'],
    color: 'from-orange-500 to-red-500',
    bg: 'bg-orange-50',
    border: 'border-orange-200',
  },
  {
    icon: 'ri-home-4-line',
    title: 'Local Moving',
    subtitle: 'Southern California Experts',
    description: 'Moving within Southern California? Our experienced local moving crews know every neighborhood from Irvine to Indio. Fast, efficient, and affordable moves with upfront hourly or flat-rate pricing.',
    features: ['Hourly and flat-rate options', 'Local area expertise', 'Residential & apartment moves', 'Efficient same-day crews', 'No hidden fees'],
    color: 'from-amber-500 to-orange-500',
    bg: 'bg-amber-50',
    border: 'border-amber-200',
  },
  {
    icon: 'ri-route-line',
    title: 'Long-Distance Moving',
    subtitle: 'Statewide & Cross-Country',
    description: 'Relocating out of California? We move you anywhere in the U.S. with the same care you\'d expect from a local move. Real-time tracking, dedicated coordinator, and binding estimate options available.',
    features: ['Real-time shipment tracking', 'Binding estimate options', 'Dedicated move coordinator', 'Delivery window flexibility', 'Full valuation coverage available'],
    color: 'from-sky-500 to-cyan-500',
    bg: 'bg-sky-50',
    border: 'border-sky-200',
  },
  {
    icon: 'ri-building-4-line',
    title: 'Office & Commercial Moving',
    subtitle: 'Zero Downtime Business Moves',
    description: 'Minimize business disruption with our commercial moving team. We specialize in office relocations, retail transitions, and warehouse moves — planned precisely and executed with zero chaos.',
    features: ['After-hours & weekend moves', 'IT equipment handling', 'Cubicle & furniture installation', 'Inventory tracking', 'Confidential document handling'],
    color: 'from-emerald-500 to-teal-500',
    bg: 'bg-emerald-50',
    border: 'border-emerald-200',
  },
  {
    icon: 'ri-archive-2-line',
    title: 'Packing & Unpacking',
    subtitle: 'Full-Service Packing Solutions',
    description: 'Let our professional packers handle the most time-consuming part of your move. We use premium materials and proven techniques to ensure every item — fragile or oversized — arrives safely.',
    features: ['Full & partial packing options', 'Professional-grade materials', 'Dish & glassware specialty wrapping', 'Labeling & inventory system', 'Unpacking & debris removal'],
    color: 'from-violet-500 to-purple-500',
    bg: 'bg-violet-50',
    border: 'border-violet-200',
  },
  {
    icon: 'ri-upload-cloud-2-line',
    title: 'Loading & Unloading',
    subtitle: 'Expert Labor You Can Count On',
    description: 'Already have a truck or container? Hire our experienced moving labor to do the heavy lifting. We load and unload safely, efficiently, and with furniture protection on every job.',
    features: ['Rented truck or container loading', 'POD & storage unit loading', 'Furniture blanket & pad protection', 'Efficient, safe stacking', 'Flexible hourly scheduling'],
    color: 'from-rose-500 to-pink-500',
    bg: 'bg-rose-50',
    border: 'border-rose-200',
  },
  {
    icon: 'ri-vip-crown-2-line',
    title: 'Specialty & Large Item Moving',
    subtitle: 'Pianos, Antiques, Fine Art & More',
    description: 'Some items need extra care. Our specialty team is trained to handle pianos, grandfather clocks, fine art, antiques, wine collections, and oversized items with precision and confidence.',
    features: ['Piano moving (upright & grand)', 'Fine art & sculpture handling', 'Antique furniture expertise', 'Custom crating available', 'Climate-sensitive item care'],
    color: 'from-teal-500 to-cyan-600',
    bg: 'bg-teal-50',
    border: 'border-teal-200',
  },
];

export default function ServiceCards() {
  return (
    <section className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block bg-orange-100 text-orange-600 text-sm font-bold px-4 py-2 rounded-full mb-4">
            What We Offer
          </span>
          <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-4">
            Complete Moving Solutions for Every Need
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto text-lg">
            Every service is backed by 20+ years of experience, licensed &amp; insured professionals, and a commitment to careful, stress-free moving.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {services.map((service) => (
            <div key={service.title}
              className={`bg-white rounded-2xl border ${service.border} overflow-hidden hover:-translate-y-1 transition-all duration-300 group flex flex-col`}>
              <div className={`h-1.5 bg-gradient-to-r ${service.color}`}></div>
              <div className="p-7 flex-1">
                <div className={`w-14 h-14 flex items-center justify-center ${service.bg} rounded-2xl mb-5 group-hover:scale-110 transition-transform`}>
                  <i className={`${service.icon} text-2xl bg-gradient-to-r ${service.color} bg-clip-text text-transparent`}
                    style={{ WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}></i>
                </div>
                <h3 className="text-xl font-black text-slate-900 mb-1">{service.title}</h3>
                <p className={`text-sm font-semibold mb-4 bg-gradient-to-r ${service.color} bg-clip-text text-transparent`}
                  style={{ WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                  {service.subtitle}
                </p>
                <p className="text-slate-600 text-sm leading-relaxed mb-5">{service.description}</p>
                <ul className="space-y-2">
                  {service.features.map((f) => (
                    <li key={f} className="flex items-center gap-2 text-sm text-slate-700">
                      <div className={`w-5 h-5 flex items-center justify-center rounded-full bg-gradient-to-r ${service.color} flex-shrink-0`}>
                        <i className="ri-check-line text-white text-xs"></i>
                      </div>
                      {f}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="px-7 pb-7">
                <a href="tel:7606257767"
                  className={`block w-full text-center py-3 rounded-xl font-bold text-sm bg-gradient-to-r ${service.color} text-white hover:opacity-90 transition-all whitespace-nowrap`}>
                  Get a Quote for This Service
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
